<template>
	<div class="jm-page">
		<div class="jm-back" @click="back">
			<i class="el-icon-arrow-left"></i>
			<div class="jm-back-text">返回</div>
		</div>
		<!-- 上方空白占位 -->
		<div class="jm-spacer" v-if="!settings.isStart">
			<span>每10分钟进线 3 名客户</span>
			<el-button type="primary" @click="$refs.productModal.handleStart()">开始</el-button>
			<span>实操练习疑问，或者问题反馈的途径：<br> 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈</span>
		</div>
		<div class="jm-spacer" v-else>
			<span>实操练习疑问，或者问题反馈的途径：<br> 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈</span>
			<el-button v-if="hasProducts" type="danger" @click="$refs.productModal.showProducts()">产品须知</el-button>
			<div style="display: flex;align-items: center;gap: 10px;">
				<span style="font-weight: bold;color: black;">推荐回复</span>
				<el-switch v-model="settings.isRecommendReply" @change="changeRecommendReply"/>
			</div>
			<div style="font-size: 20px;font-weight: bold;color: black;">{{ formattedTime }}</div>
			<el-button type="warning" @click="stopTrain">退出</el-button>
			<span>回复数：{{ totalReplyCount }} 打字速度：{{ typingSpeedWPM }}字/分钟 <br>首次响应时间：{{ firstResponseAvgSec }}秒 平均响应时间：{{ avgResponseSec }}秒</span>
		</div>
		<!-- 下方 1311 x 751 容器（相对定位） -->
		<div class="jm-container" v-show="settings.pageType == 1 || settings.pageType == 2">
			<!-- 使用等宽高图片作为背景，不直接设置在容器上 -->
			<img v-show="settings.pageType == 1" class="jm-bg" src="@/assets/images/jingmai/dd_reply.png" alt="" />
			<img v-show="settings.pageType == 2" class="jm-bg" src="@/assets/images/jingmai/dd_order.png" alt="" />
			<!-- 业务内容写在这里 -->
			<div class="jm-content">
				<div class="shop-name">飞鸽对练实操店铺</div>
				<div class="xiaoer-name">练习账号</div>
				<el-select v-model="settings.onlineStatus" placeholder="请选择" class="status-select" :class="getStatusClass(settings.onlineStatus)">
					<el-option label="接待" value="1"></el-option>
					<el-option label="小休" value="2"></el-option>
					<el-option label="挂起" value="3"></el-option>
				</el-select>
				<div class="train-session-list">
					<div
						class="ts-item"
						v-for="s in (settings.trainSession || [])"
						:key="s.id || s.veruser"
						:class="{ current: s.isCurrent, replied: !s.isCurrent && !s.didReply }"
						@click="selectSession(s)"
					>
						<img src="@/assets/images/jingmai/monitorPhoto.png" class="ts-avatar"/>
						<div class="ts-name">{{ s.veruser }}</div>
					</div>
				</div>
				<div class="chat-msg-header" v-if="currentSession">
					<img src="@/assets/images/jingmai/monitorPhoto.png" class="cmh-avatar" />
					<div class="cmh-name" :title="currentSession.veruser">{{ currentSession.veruser }}</div>
					<div style="flex: 1;"></div>
					<div class="cmh-actions">
						<i class="el-icon-star-off cmh-action"></i>
						<i class="el-icon-warning-outline cmh-action"></i>
						<el-popover v-model="transferPopoverVisible" placement="bottom-start" width="300" trigger="click" popper-class="transfer-pop">
							<div class="transfer-pop">
								<div class="tp-tabs">
									<div class="tp-tab active">转接到客服</div>
									<div class="tp-tab">转接到组</div>
								</div>
								<div class="tp-search">
									<el-input disabled size="small" placeholder="请输入在线客服昵称" suffix-icon="el-icon-search"></el-input>
								</div>
								<div class="tp-list">
									<div class="tp-item" @click="saveActionRecord('TRANSFER_AFTER_SALE','已转接给售后客服:001')">
										<span class="tp-dot online"></span>
										<span class="tp-name">售后客服001</span>
									</div>
								</div>
							</div>
							<span slot="reference" class="cmh-icon-wrap">
								<i class="el-icon-user cmh-action"></i>
								<img class="cmh-badge" src="@/assets/images/jingmai/zhihuan.png" />
							</span>
						</el-popover>
						<el-tooltip content="关闭会话" placement="top" effect="dark">
							<i class="el-icon-switch-button cmh-action" @click="closeSession"></i>
						</el-tooltip>
					</div>
				</div>
				<div class="chat-msg-content" v-if="currentSession" ref="chatContent">
					<div class="chat-msg-list">
						<div v-for="(msg, idx) in currentMessages" :key="msg.id || idx" class="msg-item" >
							<img src="@/assets/images/jingmai/monitorPhoto.png" class="msg-avatar"/>
							<div class="msg-main">
								<div class="msg-header">
									<span class="msg-name">{{ msg.fromName || '对方' }}</span>
									<span class="msg-time">{{ formatMsgTime(msg.sendTime) }}</span>
								</div>
								<order-msg-card
									v-if="msg.questionType === '卡片' && findOrderById(msg.questionOrderId)"
									:order="findOrderById(msg.questionOrderId)"
									platform="douyin"
								/>
								<template v-else>
									<div class="msg-text" v-html="msg.question"></div>
									<img v-if="msg.questionImg" :src="msg.questionImg" class="msg-image" />
								</template>
								<div class="ref-title"  @click="msg.fold = !msg.fold">{{ msg.fold ? '查看参考答案' : '收起参考答案' }}</div>
                                <div class="msg-reference" v-if="!msg.fold">
                                    <div class="ref-label">参考回复：</div>
                                    <div
                                        class="ref-body"
                                        v-html="msg.answer"
                                        @copy.prevent
                                        @cut.prevent
                                        @contextmenu.prevent
                                        @selectstart.prevent
                                        @dragstart.prevent
                                    ></div>
                                </div>
								<div class="reply-list" v-if="(msg.replyList || []).length">
									<div class="reply-item" v-for="(rep, rIdx) in msg.replyList" :key="rep.id || rIdx">
										<div class="msg-header right">
											<span class="msg-time">{{ formatMsgTime(rep.sendTime) }}</span>
											<img src="@/assets/images/jingmai/monitorPhoto.png" class="msg-avatar"/>
										</div>
										<div class="msg-text msg-rich">
											<template v-for="(node, nIdx) in parseContent(rep.content)">
												<img v-if="node.type==='img'" :key="'img-'+nIdx" :src="node.src" class="msg-image" />
												<span v-else :key="'txt-'+nIdx" style="display: block;">{{ node.text }}</span>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="chat-msg-toolbar">
					<el-button type="primary" size="small" @click="closeSession">关闭会话</el-button>
					<el-button type="primary" size="small" @click="sendReply">发送</el-button>
				</div>
				<div class="chat-msg-input">
					<el-input
						type="textarea"
						v-model="replyText"
						:rows="6"
						placeholder="请输入回复内容..."
						resize="none"
						class="reply-textarea"
						@keydown.native="onReplyKeydown"
						@input="onReplyInput"
						@paste.native="onReplyPaste"
					></el-input>
				</div>
				<!-- 快捷短语提示框 -->
				<div v-if="showQuickReplySuggestions" class="quick-reply-suggestions">
						<div 
							v-for="(item, index) in quickReplySuggestions" 
							:key="item.id"
							class="suggestion-item"
							:class="{ active: index === selectedSuggestionIndex }"
							@click="selectSuggestion(item)"
							@mouseenter="selectedSuggestionIndex = index"
						>
							<span class="suggestion-text">个</span>
							<span class="suggestion-code">{{ item.quicktext }}</span>
							<span class="suggestion-content">{{ item.replytext }}</span>
						</div>
				</div>
				<el-input v-if="settings.pageType == 1" v-model="keyword" placeholder="输入关键词搜索短语或编码" clearable class="keyword-input"
					@input="onKeywordInput"></el-input>
				<div v-if="settings.pageType == 1" class="fast-reply-content">
					<div class="fr-group" v-for="g in filteredFastReplyList" :key="g.id">
						<div class="fr-group-header" @click="toggleGroup(g.id)">
							<i :class="settings.collapsedGroups[g.id] ? 'el-icon-caret-right' : 'el-icon-caret-bottom'"></i>
							<span class="fr-group-title">{{ g.name }} ({{ (g.filteredReplyList || []).length }})</span>
						</div>
						<div v-show="!settings.collapsedGroups[g.id]" class="fr-group-body">
							<div class="fr-item" v-for="r in (g.filteredReplyList || [])" :key="r.id">
								<span class="fr-quick" style="font-weight: 800;">/{{ r.quicktext }} |</span>
								<span class="fr-text" @click="onClickReply(r)">{{ r.replytext }}</span>
								<div class="fr-actions">
									<span @click="menuDeleteReply(r)">删除</span>
									<span @click="menuEditReply(r,g)">编辑</span>
									<span @click="onClickReply(r)">发送</span>
								</div>
							</div>
						</div>
					</div>
				</div>
                <div v-if="settings.pageType == 1" class="add-reply-btn" @click="newFastReply"></div>
				<div v-if="settings.pageType == 2 && matchedOrder" class="orders-list">
					<div class="order-card">
						<div class="oc-head">
							<div class="oc-line1">
								<span class="oc-status">{{ matchedOrder.status }}</span>
								<span class="oc-no">{{ orderHeader.orderNo }}</span>
								<span class="oc-icons">
									<el-popover v-model="notePopoverVisible" placement="bottom-start" trigger="click" width="320" popper-class="order-note-pop">
										<div class="onp-wrap">
											<div class="onp-head">
												<span>订单备注</span>
											</div>
											<div class="onp-flags">
												<label v-for="(c,i) in noteFlagColors" :key="'f_'+i" class="onp-flag">
													<input type="radio" name="noteFlag" :value="i" v-model="noteFlagIndex" />
													<span class="dot" :style="{ background:c }"></span>
												</label>
												<label class="onp-flag">
													<input type="radio" name="noteFlag" :value="4" v-model="noteFlagIndex" />
													<span class="dot" style="margin-top: -12px;">🚩</span>
												</label>
											</div>
											<div class="onp-text">
												<el-input type="textarea" :rows="5" v-model="noteText" placeholder="请输入备注内容"></el-input>
											</div>
											<div class="onp-check">
												<el-checkbox disabled>自动添加暗注人和时间到末尾</el-checkbox>
											</div>
											<div class="onp-foot">
												<el-button type="primary" size="mini" @click="onNoteConfirm">确定</el-button>
												<el-button size="mini" @click="notePopoverVisible=false">取消</el-button>
											</div>
										</div>
										<span slot="reference" class="oc-badge" style="cursor: pointer;">备</span>
									</el-popover>
									<span class="oc-badge">详</span>
								</span>
							</div>
							<div class="oc-time">下单：{{ orderHeader.orderTime }}</div>
						</div>
						<div class="oc-body">
							<img :src="matchedOrder.imgurl" class="oc-img"/>
							<div class="oc-info">
								<div class="oc-title" :title="matchedOrder.productName">{{ matchedOrder.productName }}</div>
								<div class="oc-price">实付: <span style="font-weight: 700;">¥ {{ matchedOrder.price.toFixed(2) }}</span></div>
								<div class="oc-tags"><span>安心购</span><span>环保包装</span><span>运费险</span></div>
								<div class="oc-spec">规格：{{ matchedOrder.size || '默认' }}</div>
								<div class="oc-code">编码：{{ matchedOrder.id }}</div>
							</div>
							<div class="oc-side">
								<div class="oc-btns">
									<div class="btn">核对地址</div>
									<div class="btn">催付</div>
									<div class="btn">改价</div>
									<div class="btn">改地址</div>
								</div>
							</div>
						</div>
						<div class="oc-recv">
							<div class="row title">收货信息</div>
							<div class="row">{{ matchedOrder.name }}  {{ matchedOrder.phone }}</div>
							<div class="row">{{ matchedOrder.address }}</div>
						</div>
						<div class="oc-ship" v-if="matchedOrder.status == '待发货'">承诺发货：1天8小时48分钟54秒内发货</div>
						<div class="oc-foot">
							<span class="label">订单金额</span>
							<span class="value">¥ {{ matchedOrder.price.toFixed(2) }}<em class="ship">（含运费 ¥0.00）</em></span>
						</div>
					</div>
				</div>

				<div class="action-order-btn" @click="settings.pageType = 2"></div>
				<div class="action-reply-btn" @click="settings.pageType = 1"></div>
				<div class="action-import-btn" @click="settings.pageType = 3"></div>
			</div>
		</div>
		<div class="jm-container" v-show="settings.pageType == 3">
			<img class="jm-bg" src="@/assets/images/jingmai/dd_fast-import.png" alt="" />
			<div class="jm-content">
				<div class="action-chat-btn" @click="settings.pageType = 1"></div>
				<div class="fast-reply-group">
					<div class="frg-scroll">
						<div class="frg-item" :class="{ active: settings.selectedFrgId === 'all' }" @click="onSelectFrgAll">全部</div>
						<div class="frg-item frg-add" @click="settings.showGroupManage = true">+ 新增分组</div>
						<div class="frg-item" :class="{ active: settings.selectedFrgId === g.id }" v-for="g in settings.groups" :key="g.id" @click="onSelectFrg(g)">{{ g.name }}</div>
					</div>
				</div>
				<div class="fast-reply-toolbar">
					<div class="frt-left">
						<div class="frt-count">共{{ selectedGroupReplyCount }}条</div>
						<div class="frt-btn" @click="showImport = true">批量导入</div>
					</div>
					<div class="frt-right">
						<div class="frt-btn" @click="settings.showGroupManage = true">管理分组</div>
						<div class="frt-btn frt-btn-primary" @click="menuAddReply">新建短语</div>
					</div>
				</div>
				<div class="fast-reply-list">
					<div class="fr-table">
						<div class="fr-thead fr-tr">
							<div class="fr-th col-index">序号</div>
							<div class="fr-th col-quick">快捷短语编码</div>
							<div class="fr-th col-text">快捷短语</div>
							<div class="fr-th col-actions">操作</div>
						</div>
						<div class="fr-tbody">
							<div class="fr-tr" v-for="(r, i) in displayedReplies" :key="(r.id || i)+'_row'">
								<div class="fr-td col-index">{{ i + 1 }}</div>
								<div class="fr-td col-quick">/{{ r.quicktext }}</div>
								<div class="fr-td col-text" :title="r.replytext">{{ r.replytext }}</div>
								<div class="fr-td col-actions">
									<div class="fr-op-btn" @click="menuEditReply(r,{id:settings.selectedFrgId})">编辑</div>
									<div class="fr-op-btn danger" @click="menuDeleteReply(r)">删除</div>
								</div>
							</div>
							<div class="fr-empty" v-if="!displayedReplies || displayedReplies.length === 0">暂无数据</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
		<FastReplyImportDDDialog :sceneId="sceneId" :visible.sync="showImport" @refresh="refreshFastReply" />
		<FastReplyEditorDialog :showAddGroup="false" :sceneId="sceneId" :visible.sync="showEditor" :defaultGroupId="settings.defaultGroupId" :value="editorValue" @refresh="refreshFastReply" />
		<TrainScoreDialog :result="trainResult" :visible.sync="showScore" @onRestart="restartTrain" @onViewResult="viewResult" />
		<GroupManageDialog :sceneId="sceneId" :visible.sync="settings.showGroupManage" :groups="fastReplyList" @refresh="refreshFastReply" />
		<CourseProductModal ref="productModal" :course-id="sceneId" @confirm="startTrain" @products-fetched="hasProducts = $event" />
	</div>
</template>

<script>
import FastReplyImportDDDialog from './components/FastReplyImportDDDialog.vue'
import FastReplyEditorDialog from './components/FastReplyEditorDialog.vue'
import TrainScoreDialog from './components/TrainScoreDialog.vue'
import GroupManageDialog from './components/GroupManageDialog.vue'
import orders from '@/page/train/FBT/data/order'
import OrderMsgCard from './components/OrderMsgCard.vue'
import CourseProductModal from './components/CourseProductModal.vue'
export default {
	name: 'doudianChat',
	data() {
		return {
			transferPopoverVisible: false,
			notePopoverVisible: false,
			noteFlagColors: ['#a0a0a0','#a0a0a0','#a0a0a0','#a0a0a0'],
			noteFlagIndex: 0,
			noteText: '',
			sceneId: this.$route.query.sceneId,
			hasProducts: false,
			settings: {
				isStart: false,
				onlineStatus: '1',
				isRecommendReply: false,
				time: 0,
				collapsedGroups: {},
				groups: [],
				defaultGroupId: null,
				trainId: null,
				trainSession:[],
				isMaxSession: false,
                pageType:1, //1快捷短语 2订单 3导入
				selectedFrgId: 'all',
				showGroupManage: false,
			},
			timer: null,
			taskATimer: null,
			taskBTimer: null,
			taskCTimer: null,
			keyword: '',
			showImport: false,
			showEditor: false,
			showScore: false,
			trainResult: null,
			editorValue: null,
			// 外部订单数据：jingmai
			ordersJingmai: orders.douyin,
			
			menu: { visible: false, x: 0, y: 0, group: null, reply: null, type: 'group' },
			fastReplyList: [],
			replyText: '',
			fullLoading: null,
			showQuickReplySuggestions: false,
			quickReplySuggestions: [],
			selectedSuggestionIndex: 0,
			// 打字速度（实用口径 + 粘贴修正）
			typingStartMs: null,
			typingAccumMs: 0,
			typedCharsTotal: 0,
			pastedCharsCurrent: 0,
			// 订单头部展示信息
			orderHeader: { orderNo: '', orderTime: '', orderPayTime: '' },
			
		};
	},
	components: { FastReplyImportDDDialog, FastReplyEditorDialog, TrainScoreDialog, GroupManageDialog, OrderMsgCard, CourseProductModal },
	mounted() {
		this.refreshFastReply();
		// 生成随机订单号和下单时间（早于昨天）
		this.generateOrderHeader();
	},
	beforeDestroy() {
		// 组件销毁前清理所有定时器，防止内存泄漏
		if (this.timer) { clearInterval(this.timer); this.timer = null; }
		if (this.taskATimer) { clearInterval(this.taskATimer); this.taskATimer = null; }
		if (this.taskBTimer) { clearInterval(this.taskBTimer); this.taskBTimer = null; }
		if (this.taskCTimer) { clearInterval(this.taskCTimer); this.taskCTimer = null; }
		if (this.fullLoading) { this.fullLoading.close(); this.fullLoading = null; }
	},
	watch: {
		matchedOrder: {
			handler(newVal, oldVal) {
				if (newVal && !oldVal) {
					this.generateOrderHeader();
				}
			}
		}
	},
	computed: {
		matchedOrder() {
			const session = this.currentSession;
			if (!session || !Array.isArray(session.quesList) || !session.quesList.length) return null;
			// 取当前对方发出的最后一个问题（已送达：sendTime 存在）的 questionOrderId
			let lastDelivered = null;
			for (let i = session.quesList.length - 1; i >= 0; i--) {
				const q = session.quesList[i];
				if (q && q.sendTime && q.questionOrderId) { lastDelivered = q; break; }
			}
			if (!lastDelivered) return null;
			const list = this.ordersJingmai || [];
			return list.find(o => String(o.id) === String(lastDelivered.questionOrderId)) || null;
		},
		formattedTime() {
			const t = Math.max(0, this.settings.time | 0);
			const m = String(Math.floor(t / 60)).padStart(2, '0');
			const s = String(t % 60).padStart(2, '0');
			return `00:${m}:${s}`;
		},
		currentSession() {
			return (this.settings.trainSession || []).find(s => s.isCurrent) || null;
		},
		currentMessages() {
			if (!this.currentSession) return [];
			var messages = [];
			this.currentSession.quesList.forEach(q => {
				if (q.sendTime) {
					console.log('[order-card]', { questionType: q.questionType, questionOrderId: q.questionOrderId, matched: !!this.findOrderById(q.questionOrderId), q: q });
					messages.push(q);
				}
			});
			return messages;
		},
		totalReplyCount() {
			let count = 0;
			(this.settings.trainSession || []).forEach(s => {
				(s.quesList || []).forEach(q => {
					if (Array.isArray(q.replyList)) {
						count += q.replyList.length;
					}
				});
			});
			return count;
		},
		firstResponseAvgSec() {
			const sessions = this.settings.trainSession || [];
			const deltas = [];
			sessions.forEach(s => {
				const firstQ = (s.quesList || [])[0];
				if (!firstQ || !firstQ.sendTime) return;
				const firstReply = (firstQ.replyList || []).find(r => r && r.sendTime);
				if (!firstReply) return;
				const deltaMs = Number(firstReply.sendTime) - Number(firstQ.sendTime);
				if (isFinite(deltaMs) && deltaMs >= 0) {
					deltas.push(deltaMs);
				}
			});
			if (!deltas.length) return 0;
			const avgMs = deltas.reduce((a,b) => a + b, 0) / deltas.length;
			return Math.round(avgMs / 1000);
		},
		avgResponseSec() {
			const sessions = this.settings.trainSession || [];
			const deltas = [];
			sessions.forEach(s => {
				(s.quesList || []).forEach(q => {
					if (!q || !q.sendTime) return;
					const firstReply = (q.replyList || []).find(r => r && r.sendTime);
					if (!firstReply) return;
					const deltaMs = Number(firstReply.sendTime) - Number(q.sendTime);
					if (isFinite(deltaMs) && deltaMs >= 0) {
						deltas.push(deltaMs);
					}
				});
			});
			if (!deltas.length) return 0;
			const avgMs = deltas.reduce((a,b) => a + b, 0) / deltas.length;
			return Math.round(avgMs / 1000);
		},
		typingSpeedWPM() {
			const ms = Number(this.typingAccumMs) || 0;
			const chars = Number(this.typedCharsTotal) || 0;
			if (ms <= 0 || chars <= 0) return 0;
			const minutes = ms / 60000;
			if (minutes <= 0) return 0;
			return Math.round(chars / minutes);
		},
		filteredFastReplyList() {
			if (!this.keyword || !this.keyword.trim()) {
				// 无关键词时返回原始数据，展开所有分组
				return (this.fastReplyList || []).map(g => ({
					...g,
					filteredReplyList: g.replyList || []
				}));
			}
			
			const keyword = this.keyword.trim().toLowerCase();
			return (this.fastReplyList || []).map(g => {
				const filtered = (g.replyList || []).filter(r => {
					const quicktext = (r.quicktext || '').toLowerCase();
					const replytext = (r.replytext || '').toLowerCase();
					return quicktext.includes(keyword) || replytext.includes(keyword);
				});
				
				return {
					...g,
					filteredReplyList: filtered
				};
			}).filter(g => g.filteredReplyList.length > 0); // 只显示有匹配项的分组
		},
		selectedGroupReplyCount() {
			// 计算当前选中分组下的快捷回复条数；all 统计全部
			const source = (!this.keyword || !this.keyword.trim())
				? (this.fastReplyList || []).map(g => ({ ...g, filteredReplyList: g.replyList || [] }))
				: this.filteredFastReplyList;
			if (this.settings.selectedFrgId === 'all') {
				return source.reduce((sum, g) => sum + (g.filteredReplyList ? g.filteredReplyList.length : 0), 0);
			}
			const g = source.find(x => x.id === this.settings.selectedFrgId);
			return g ? (g.filteredReplyList ? g.filteredReplyList.length : 0) : 0;
		},
		displayedReplies() {
			// 根据选中分组和关键词，得到要在表格里展示的快捷短语列表
			const groups = (!this.keyword || !this.keyword.trim())
				? (this.fastReplyList || []).map(g => ({ ...g, filteredReplyList: g.replyList || [] }))
				: this.filteredFastReplyList;
			if (this.settings.selectedFrgId === 'all') {
				return groups.flatMap(g => g.filteredReplyList || []);
			}
			const g = groups.find(x => x.id === this.settings.selectedFrgId);
			return g ? (g.filteredReplyList || []) : [];
		}
	},
	methods: {
		// 根据 questionOrderId 匹配本地订单数据，用于聊天流订单卡片
		findOrderById(orderId) {
			const list = this.ordersJingmai || [];
			let order = (orderId != null && orderId !== '') ? list.find(o => String(o.id) === String(orderId)) : null;
			// 匹配不到用 1001 兜底
			return order || list.find(o => String(o.id) === '1001') || null;
		},
		onNoteConfirm() {
			const text = (this.noteText || '').trim();
			if (!text) {
				this.$message.warning('请输入备注内容');
				return;
			}
			this.notePopoverVisible = false;
			this.saveActionRecord('REMARK_MODIFY',text);
		},
		saveActionRecord(actionType,text) {
			this.transferPopoverVisible = false;
			let target = null;
			const list = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
			for (let i = list.length - 1; i >= 0; i--) {
				const q = list[i];
				if (q && q.sendTime) { target = q; break; }
			}
			if (!target) { this.$message({ type: 'warning', message: '暂无可回复的问题' }); return; }
			let data = {
				trainRecordId: this.settings.trainId,
				sessionId: this.currentSession.id,
				questionId: target.id,
				questionOrderId: target.questionOrderId,
				actionType: actionType
			}
			if (actionType == 'REMARK_MODIFY') {
				data.opeRemark = '备注：' + text;
			}
			this.$http.post(API_ROOT.newcustomer + '/train/saveActionRecord', data).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.$message({ type: 'success', message: '操作成功' });
				}
			});
			if (actionType == 'REMARK_MODIFY') {
				return;
			}
			if (!Array.isArray(target.replyList)) { this.$set(target, 'replyList', []); }
			const now = Date.now();
			target.replyList.push({ id: 'local-' + Date.now(), from: 'self', fromName: '', sendTime: now, content: text });
			this.sendMsg(0,text,0,'','',target.id,this.currentSession && this.currentSession.id);
		},
		sendReply() {
			const text = (this.replyText || '').trim();
			if(!text || !this.currentSession){
				this.$message({ type: 'error', message: '请先选择一个会话' });
				return;
			}
			if(text.length > 2000){
				this.$message({ type: 'warning', message: '消息内容过长，请控制在2000字符以内' });
				return;
			}
			let target = null;
			const list = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
			for (let i = list.length - 1; i >= 0; i--) {
				const q = list[i];
				if (q && q.sendTime) { target = q; break; }
			}
			if (!target) { this.$message({ type: 'warning', message: '暂无可回复的问题' }); return; }
			if (!Array.isArray(target.replyList)) { this.$set(target, 'replyList', []); }
			const now = Date.now();
			if (this.typingStartMs) {
				this.typingAccumMs += Math.max(0, now - this.typingStartMs);
			}
			const effectiveChars = Math.max(0, text.length - (this.pastedCharsCurrent || 0));
			this.typedCharsTotal += effectiveChars;
			const localMinutes = ((this.typingStartMs ? (now - this.typingStartMs) : 0) || 0) / 60000;
			const localSpeed = localMinutes > 0 ? Math.round(effectiveChars / localMinutes) : 0;
			this.typingStartMs = null;
			this.pastedCharsCurrent = 0;
			target.replyList.push({ id: 'local-' + Date.now(), from: 'self', fromName: '', sendTime: now, content: text });
			this.sendMsg(0,text,localSpeed,'','',target.id,this.currentSession && this.currentSession.id);
			this.replyText = '';
			this.$nextTick(() => { this.scrollChatToBottom(); });
		},
		onSelectFrgAll() {
			this.settings.selectedFrgId = 'all';
		},
		onSelectFrg(group) {
			this.settings.selectedFrgId = group && group.id;
		},
		getStatusClass(status) {
			switch(status) {
				case '1': return 'status-online';
				case '2': return 'status-offline';
				case '3': return 'status-pending';
				default: return '';
			}
		},
		generateOrderHeader() {
			const pad = (n) => String(n).padStart(2, '0');
			// 订单号：年月日时分秒 + 随机4位
			const now = new Date();
			const no = `${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}${Math.floor(1000+Math.random()*9000)}`;
			// 时间：在昨天之前的随机时间
			const todayStart = new Date();
			todayStart.setHours(0,0,0,0);
			const yesterdayStart = new Date(todayStart.getTime() - 24*60*60*1000);
			const threeDaysAgo = new Date(yesterdayStart.getTime() - 3*24*60*60*1000);
			const ts = threeDaysAgo.getTime() + Math.random() * (yesterdayStart.getTime() - threeDaysAgo.getTime() - 1);
			const dt = new Date(ts);
			const timeStr = `${dt.getFullYear()}-${pad(dt.getMonth()+1)}-${pad(dt.getDate())} ${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;
			// 付款时间：下单后 1-15 分钟内
			const payDeltaMin = 1 + Math.floor(Math.random()*15);
			const payDt = new Date(dt.getTime() + payDeltaMin*60*1000);
			const payStr = `${payDt.getFullYear()}-${pad(payDt.getMonth()+1)}-${pad(payDt.getDate())} ${pad(payDt.getHours())}:${pad(payDt.getMinutes())}:${pad(payDt.getSeconds())}`;
			this.orderHeader.orderNo = no;
			this.orderHeader.orderTime = timeStr;
			this.orderHeader.orderPayTime = payStr;
		},
		watchMatchedOrder(newVal, oldVal) {
			if (newVal && !oldVal) {
				this.generateOrderHeader();
			}
		},
		onReplyKeydown(e){
			// 处理快捷短语选择；如果是回车且有建议，优先选择建议；否则继续走发送
			if (this.showQuickReplySuggestions) {
				if (e.key === 'ArrowDown') {
					e.preventDefault();
					this.selectedSuggestionIndex = Math.min(this.selectedSuggestionIndex + 1, this.quickReplySuggestions.length - 1);
					return;
				}
				if (e.key === 'ArrowUp') {
					e.preventDefault();
					this.selectedSuggestionIndex = Math.max(this.selectedSuggestionIndex - 1, 0);
					return;
				}
				if (e.key === 'Enter' && this.quickReplySuggestions.length > 0) {
					e.preventDefault();
					if (this.quickReplySuggestions[this.selectedSuggestionIndex]) {
						this.selectSuggestion(this.quickReplySuggestions[this.selectedSuggestionIndex]);
					}
					return;
				}
				if (e.key === 'Escape') {
					e.preventDefault();
					this.hideSuggestions();
					return;
				}
			}
			
			if(e.key === 'Enter' && !e.shiftKey){
				e.preventDefault();
				this.sendReply();
			}
		},
		onClickReply(item){
			if(!item) return;
			const text = (item.replytext || '').trim();
			if(!text) return;
			// 将快捷短语填充到输入框，若已有内容则在末尾追加换行
			if(this.replyText){
				this.replyText = this.replyText.replace(/\s*$/, '') + '\n' + text;
			}else{
				this.replyText = text;
			}
			this.$nextTick(() => {
				const ta = this.$el.querySelector('.reply-textarea textarea');
				if(ta){ ta.focus(); ta.selectionStart = ta.selectionEnd = this.replyText.length; }
			});
		},
		back() {
			this.$router.back();
		},
		changeRecommendReply() {
			this.settings.trainSession.forEach(s => {
				s.quesList.forEach(q => {
					q.fold = !this.settings.isRecommendReply;
				});
			});
		},
		startTrain() {
			this.settings.isStart = true;
			this.settings.time = 60 * 10; // 10分钟
			if (this.timer) clearInterval(this.timer);
			if (this.taskATimer) clearInterval(this.taskATimer);
			if (this.taskBTimer) clearInterval(this.taskBTimer);
			if (this.taskCTimer) clearInterval(this.taskCTimer);
			this.timer = setInterval(() => {
				if (this.settings.time > 0) {
					this.settings.time -= 1;
					if (this.settings.time == 60 * 7) {
						this.newSession();
						this.startTaskB();
					}
					if (this.settings.time == 60 * 4) {
						this.newSession();
						this.startTaskC();
						this.settings.isMaxSession = true;
					}
				} else {
					clearInterval(this.timer);
					this.timer = null;
					if (this.settings.trainSession.length == 0) {
						this.submitTrain();
					}else{
						this.$alert('已经不会有客户进线了，接待完客户依次关闭对话即可评分', '训练结束', {
							confirmButtonText: '确定',
							type: 'info'
						});
					}
				}
			}, 1000);
			
			
			this.$http.get(API_ROOT.newcustomer + '/train/initTrain?exam=0&sessionnum=3&dependid=' + this.sceneId).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.settings.trainId = result.data.trainId;
					this.newSession();
					this.startTaskA();
				} else {
					this.$message({ type: 'error', message: result.msg || '开始训练失败' });
				}
			});
		},
		startTaskA(){
			// 独立的任务定时器：不随倒计时结束而停止
			this.taskATimer = setInterval(() => {
				console.log('taskATimer');
				// 从 trainSession 找第一个元素
				const sessions = this.settings.trainSession || [];
				if (!sessions.length) return;
				const firstSession = sessions[0];
				const quesList = Array.isArray(firstSession.quesList) ? firstSession.quesList : [];
				if (!quesList.length) return;
				// 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
				let idx = -1;
				for (let i = quesList.length - 1; i >= 0; i--) {
					const q = quesList[i];
					if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) { idx = i; break; }
				}
				if (idx === -1) return;
				console.log('idx',idx);
				const nextIdx = idx + 1;
				if (nextIdx >= quesList.length) return;
				const nextQ = quesList[nextIdx];
				console.log('nextQ',nextQ.answer);
				if (!nextQ) return;
				// 若下一题尚未"送达"，则激活它
				if (!nextQ.sendTime) {
					nextQ.sendTime = Date.now();
					// 触发一条“对方”消息，用于保持与新会话一致的行为
					this.sendMsg(1, '', 0, nextQ.answer, firstSession.veruser, nextQ.id, firstSession.id);
					if (!firstSession.isCurrent) {
						firstSession.didReply = false;
					}
				}
			}, 15000);
		},
		startTaskB(){
			this.taskBTimer = setInterval(() => {
				console.log('taskBTimer');
				// 从 trainSession 找第一个元素
				const sessions = this.settings.trainSession || [];
				if (!sessions.length || sessions.length <= 1) return;
				const secondSession = sessions[1];
				const quesList = Array.isArray(secondSession.quesList) ? secondSession.quesList : [];
				if (!quesList.length) return;
				// 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
				let idx = -1;
				for (let i = quesList.length - 1; i >= 0; i--) {
					const q = quesList[i];
					if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) { idx = i; break; }
				}
				if (idx === -1) return;
				const nextIdx = idx + 1;
				if (nextIdx >= quesList.length) return;
				const nextQ = quesList[nextIdx];
				if (!nextQ) return;
				// 若下一题尚未"送达"，则激活它
				if (!nextQ.sendTime) {
					nextQ.sendTime = Date.now();
					// 触发一条“对方”消息，用于保持与新会话一致的行为
					this.sendMsg(1, '', 0, nextQ.answer, secondSession.veruser, nextQ.id, secondSession.id);
					if (!secondSession.isCurrent) {
						secondSession.didReply = false;
					}
				}
			}, 15000);
		},
		startTaskC(){
			this.taskCTimer = setInterval(() => {
				console.log('taskCTimer');
				// 从 trainSession 找第一个元素
				const sessions = this.settings.trainSession || [];
				if (!sessions.length || sessions.length <= 2) return;
				const thirdSession = sessions[2];
				const quesList = Array.isArray(thirdSession.quesList) ? thirdSession.quesList : [];
				if (!quesList.length) return;
				// 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
				let idx = -1;
				for (let i = quesList.length - 1; i >= 0; i--) {
					const q = quesList[i];
					if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) { idx = i; break; }
				}
				if (idx === -1) return;
				const nextIdx = idx + 1;
				if (nextIdx >= quesList.length) return;
				const nextQ = quesList[nextIdx];
				if (!nextQ) return;
				// 若下一题尚未"送达"，则激活它
				if (!nextQ.sendTime) {
					nextQ.sendTime = Date.now();
					// 触发一条“对方”消息，用于保持与新会话一致的行为
					this.sendMsg(1, '', 0, nextQ.answer, thirdSession.veruser, nextQ.id, thirdSession.id);
					if (!thirdSession.isCurrent) {
						thirdSession.didReply = false;
					}
				}
			}, 15000);
		},
		closeSession(){
			if (!this.currentSession) return;
			const currentIndex = this.settings.trainSession.findIndex(s => s.id === this.currentSession.id);
			if (currentIndex === -1) return;

			// 检查是否存在未下发或未回复的问题
			const quesList = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
			const hasPending = quesList.some(q => !q || (!q.sendTime) || (q.sendTime && (!Array.isArray(q.replyList) || q.replyList.length === 0)));

			const doRemove = () => {
				// 移除当前会话
				this.settings.trainSession.splice(currentIndex, 1);
				// 如果数组中还有会话，选择下一个（或前一个）
				if (this.settings.trainSession.length > 0) {
					const nextIndex = currentIndex < this.settings.trainSession.length ? currentIndex : currentIndex - 1;
					this.selectSession(this.settings.trainSession[nextIndex]);
				} else {
					// 如果没有会话了，清空当前会话
					this.settings.trainSession=[];
					if(this.settings.isMaxSession){
						// 如果已经达到最大会话数，则停止训练
						if (this.settings.time <= 0) {
							this.submitTrain();
						}
					}
				}
			};

			if (hasPending) {
				this.$confirm('当前会话您还有未回复的问题，确定关闭会话？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					doRemove();
				}).catch(() => {});
			} else {
				doRemove();
			}
		},
		submitTrain(){
			this.openFullLoading('提交中...');
			this.$http.post(API_ROOT.newcustomer + '/train/submitTrain', { id: this.settings.trainId }).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.getScorById();
				} else {
					this.$message({ type: 'error', message: result.msg || '提交失败' });
					this.closeFullLoading();
				}
			}, () => {
				this.$message({ type: 'error', message: '提交失败' });
				this.closeFullLoading();
			})
		},
		getScorById(){
			const self = this;
			this.$http.post(API_ROOT.newcustomer + '/train/getById', { id: this.settings.trainId }).then(res => {
				const result = res.data;
				if (result && result.success) {
					self.closeFullLoading();
					self.trainResult = result.data;
					self.showScore = true;
				}else {
					this.$message({ type: 'error', message: result.msg || '提交失败' });
					self.closeFullLoading();
				}
			}, () => {
				this.$message({ type: 'error', message: '提交失败' });
				this.closeFullLoading();
			})
		},
		openFullLoading(text) {
			if (this.fullLoading) { this.fullLoading.close(); this.fullLoading = null; }
			this.fullLoading = this.$loading({
				lock: true,
				text: text || '加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.4)'
			});
		},
		closeFullLoading() {
			if (this.fullLoading) { this.fullLoading.close(); this.fullLoading = null; }
		},
		newSession(){
			// ,batchId: 'dd0e3a32a49a49b59e3f134ea2f21fbe'
			this.$http.post(API_ROOT.newcustomer + '/train/newSession', { id: this.settings.trainId, batchId:this.$route.query.batchId}).then(res => {
				const result = res.data;
				if (result && result.success) {
					const item = result.data.trainSession[0];
					if (this.settings.trainSession.length == 0) {
						item.isCurrent = true;
						item.didReply = true;
					} else {
						item.isCurrent = false;
						item.didReply = false;
					}
					item.quesList.forEach(q => {
						q.fromName = item.veruser;
						q.sendTime = null;
						q.fold = true;
						q.replyList = [];
					});
					item.quesList[0].sendTime = Date.now();
					this.settings.trainSession.push(item);
					this.sendMsg(1,'',0,item.quesList[0].answer,item.veruser,item.quesList[0].id,item.id);
					this.$nextTick(() => { this.scrollChatToBottom(); });
				} else {
					this.$message({ type: 'error', message: result.msg || '开始训练失败' });
				}
			});
		},
		sendMsg(role,content,typingspeed,sysanswer,username,questionId,sessionId){
			var data
			if(role === 1){
				data = {
					role: 1,
					content: '',
					typingspeed: 0,
					sysanswer: sysanswer,
					username: username,
					questionId: questionId,
					sessionid: sessionId || (this.currentSession && this.currentSession.id)
				}
			}else{
				data = {
					role: 0,
					content: content,
					typingspeed: typingspeed,
					questionId: questionId,
					sessionid: sessionId || (this.currentSession && this.currentSession.id)
				}
			}
			this.$http.post(API_ROOT.newcustomer + '/train/sendMsg', data).then(res => {
				const result = res.data;
				if (result && result.success) {
					
				} else {
					this.$message({ type: 'error', message: result.msg || '发送失败' });
				}
			}).catch(err => {
				console.error('发送消息失败:', err);
				this.$message({ 
					type: 'error', 
					message: '网络错误，发送失败。请检查网络连接或稍后重试。' 
				});
			});
			this.$nextTick(() => { this.scrollChatToBottom(); });
		},
		selectSession(target){
			(this.settings.trainSession || []).forEach(s => {
				s.isCurrent = false;
			});
			target.isCurrent = true;
			target.didReply = true;
			this.$nextTick(() => { this.scrollChatToBottom(); });
		},
		stopTrain() {
			this.settings = {
				isStart: false,
				onlineStatus: '1',
				isRecommendReply: false,
				time: 0,
				collapsedGroups: {},
				groups: [],
				defaultGroupId: null,
				trainId: null,
				trainSession:[],
				isMaxSession: false,
                pageType:2, //1快捷短语 2订单 3导入
				selectedFrgId: 'all',
				showGroupManage: false,
			},
			// 重置打字统计
			this.typingStartMs = null;
			this.typingAccumMs = 0;
			this.typedCharsTotal = 0;
			this.pastedCharsCurrent = 0;
			clearInterval(this.timer);
			this.timer = null;
			if (this.taskATimer) { clearInterval(this.taskATimer); this.taskATimer = null; }
			if (this.taskBTimer) { clearInterval(this.taskBTimer); this.taskBTimer = null; }
			if (this.taskCTimer) { clearInterval(this.taskCTimer); this.taskCTimer = null; }
		},
		restartTrain() {
			this.showScore = false;
			this.stopTrain();
			this.$refs.productModal.handleStart();
		},
		viewResult() {
			this.$router.push({
				name: 'fbtTrainResult',
				query: {
					trainId: this.settings.trainId
				}
			});
			this.showScore = false;
			this.stopTrain();
		},
		onKeywordInput() {
			// 实时筛选逻辑在 computed 中处理
		},
		onReplyInput() {
			// 进入输入状态的起点：从空到非空
			const textNow = this.replyText || '';
			if (!this.typingStartMs && textNow.trim().length > 0) {
				this.typingStartMs = Date.now();
			}
			// 检测是否输入了 / 符号
			const text = this.replyText || '';
			const lastSlashIndex = text.lastIndexOf('/');
			
			if (lastSlashIndex !== -1) {
				// 获取 / 后面的内容作为搜索关键词
				const searchKeyword = text.substring(lastSlashIndex + 1).toLowerCase();
				
				if (searchKeyword.length === 0) {
					// 如果只输入了 /，显示所有快捷短语
					this.showAllQuickReplies();
				} else {
					// 根据关键词筛选快捷短语
					this.filterQuickReplies(searchKeyword);
				}
			} else {
				// 没有 / 符号，隐藏提示框
				this.hideSuggestions();
			}
			// 若清空输入，则结束当前输入段并清零本段粘贴统计
			if (textNow.trim().length === 0) {
				if (this.typingStartMs) {
					// 不累计时间（只有发送时累计），仅重置起点
					this.typingStartMs = null;
				}
				this.pastedCharsCurrent = 0;
			}
		},
		onReplyPaste(e) {
			try {
				const text = (e.clipboardData && e.clipboardData.getData('text')) || '';
				this.pastedCharsCurrent += (text || '').length;
			} catch (err) { /* ignore */ }
		},
		showAllQuickReplies() {
			const allReplies = [];
			(this.fastReplyList || []).forEach(group => {
				(group.replyList || []).forEach(reply => {
					allReplies.push(reply);
				});
			});
			this.quickReplySuggestions = allReplies.slice(0, 6); // 最多显示6个
			this.selectedSuggestionIndex = 0;
			this.showQuickReplySuggestions = true;
		},
		filterQuickReplies(keyword) {
			const filteredReplies = [];
			(this.fastReplyList || []).forEach(group => {
				(group.replyList || []).forEach(reply => {
					const quicktext = (reply.quicktext || '').toLowerCase();
					const replytext = (reply.replytext || '').toLowerCase();
					if (quicktext.includes(keyword) || replytext.includes(keyword)) {
						filteredReplies.push(reply);
					}
				});
			});
			this.quickReplySuggestions = filteredReplies.slice(0, 6); // 最多显示6个
			this.selectedSuggestionIndex = 0;
			this.showQuickReplySuggestions = true;
		},
		selectSuggestion(item) {
			if (!item) return;
			
			const text = this.replyText || '';
			const lastSlashIndex = text.lastIndexOf('/');
			
			if (lastSlashIndex !== -1) {
				// 替换 / 及其后面的内容为选中的快捷短语
				const beforeSlash = text.substring(0, lastSlashIndex);
				this.replyText = beforeSlash + item.replytext;
			} else {
				// 如果没有 / 符号，直接添加
				this.replyText = text + item.replytext;
			}
			
			this.hideSuggestions();
			
			// 聚焦到输入框
			this.$nextTick(() => {
				const textarea = this.$el.querySelector('.reply-textarea textarea');
				if (textarea) {
					textarea.focus();
					textarea.setSelectionRange(this.replyText.length, this.replyText.length);
				}
			});
		},
		hideSuggestions() {
			this.showQuickReplySuggestions = false;
			this.quickReplySuggestions = [];
			this.selectedSuggestionIndex = 0;
		},
		refreshFastReply() {
			this.$http.get(API_ROOT.newcustomer + '/train/reply/searchType?id=' + this.sceneId).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.settings.groups = Array.isArray(result.data.personalType) ? result.data.personalType : [];
				}
			});
			this.$http.post(API_ROOT.newcustomer + '/train/reply/search?type=1&sceneId=' + this.sceneId).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.fastReplyList = result.data.typeList;
				} else {
					this.$message({message: result.msg,	type: 'error'});
				}
			}, err => {
				this.$message({message: '保存失败', type: 'error'});
			})
		},
		newFastReply() {
			this.showEditor = true;
		},
		toggleGroup(id) {
			if (!this.settings.collapsedGroups) this.$set(this.settings, 'collapsedGroups', {});
			this.$set(this.settings.collapsedGroups, id, !this.settings.collapsedGroups[id]);
		},
		menuAddGroup() {
			const self = this;
			this.$prompt('请输入分组名', '新增分组', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /\S+/, // 非空
				inputErrorMessage: '分组名不能为空'
			}).then(({ value }) => {
				const name = value && value.trim();
				if (!name) return;
				this.$http.post(API_ROOT.newcustomer + '/train/reply/saveReplyType?sceneId=' + self.sceneId, { name :name }).then(res => {
					const result = res.data;
					if (result && result.success) {
						this.$message({ type: 'success', message: '保存分组成功' });
						self.refreshFastReply();
					} else {
						this.$message({ type: 'error', message: result.msg || '保存失败' });
					}
				}, () => {
					this.$message({ type: 'error', message: '保存失败' });
				});
			});
		},
        menuEditReply(reply,group) {
			// 将当前短语的数据映射到编辑弹窗所需字段
			const groupId = (group && group.id) ? group.id : '';
			this.settings.defaultGroupId = groupId;
			this.editorValue = {
				id: reply.id || '',
				content: reply.replytext || '',
				group: groupId,
				code: reply.quicktext || ''
			};
			this.showEditor = true;
		},
		/**
		 * 添加短语
		 */
		menuAddReply() {
			this.settings.defaultGroupId = this.settings.selectedFrgId == 'all' ? null : this.settings.selectedFrgId;
			this.showEditor = true;
		},
		menuDeleteReply(reply) {
			const self = this;
			this.$confirm('确定要删除这条快捷短语吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post(API_ROOT.newcustomer + '/train/reply/deleteReply', { id: reply.id }).then(res => {
					const result = res.data;
					if (result && result.success) {
						this.$message({ type: 'success', message: '删除成功' });
						self.refreshFastReply();
					} else {
						this.$message({ type: 'error', message: result.msg || '删除失败' });
					}
				}, () => {
					this.$message({ type: 'error', message: '删除失败' });
				});
			}).catch(() => {
				this.$message({ type: 'info', message: '已取消删除' });
			});
		},
		formatMsgTime(t) {
			if (!t) return '';
			const date = typeof t === 'number' ? new Date(t) : new Date(String(t));
			const y = date.getFullYear();
			const M = String(date.getMonth() + 1).padStart(2, '0');
			const d = String(date.getDate()).padStart(2, '0');
			const h = String(date.getHours()).padStart(2, '0');
			const m = String(date.getMinutes()).padStart(2, '0');
			const s = String(date.getSeconds()).padStart(2, '0');
			return `${y}-${M}-${d} ${h}:${m}:${s}`;
		},
		scrollChatToBottom() {
			const el = this.$refs && this.$refs.chatContent;
			if (!el) return;
			try {
				el.scrollTop = el.scrollHeight;
			} catch (e) { /* ignore */ }
		},
		parseContent(content) {
			// 识别普通图片链接（含查询参数），并进行图文混排
			// 匹配形如 http(s)://.../xxx.(png|jpg|jpeg|gif|webp|bmp)[?...] 的链接
			const urlRegex = /(https?:\/\/[^\s]+?\.(?:png|jpe?g|gif|webp|bmp)(?:\?[^\s]*)?)/ig;
			const nodes = [];
			const str = String(content || '');
			let lastIndex = 0;
			let match;
			while ((match = urlRegex.exec(str)) !== null) {
				const start = match.index;
				if (start > lastIndex) {
					nodes.push({ type: 'text', text: str.slice(lastIndex, start) });
				}
				nodes.push({ type: 'img', src: match[1] });
				lastIndex = urlRegex.lastIndex;
			}
			if (lastIndex < str.length) {
				nodes.push({ type: 'text', text: str.slice(lastIndex) });
			}
			return nodes.length ? nodes : [{ type: 'text', text: str }];
		},
		onClickReply(reply) {
			this.replyText = reply.replytext;
		}
	}
};
</script>

<style lang='less' scoped>
/* 页面根容器，居中显示 1311px 布局 */
.jm-page {
	width: 1448px;
	margin: 0 auto;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
	background: #fff;
	border-radius: 8px;
	padding-top: 15px;
	.jm-back {
		display: flex;
		flex-direction: row;
		align-items: center;
		cursor: pointer;
		width: 100px;
		margin-left: 8px;
		margin-bottom: 10px;

		.el-icon-arrow-left {
			margin-right: 10px;
		}

		.jm-back-text {
			margin-left: 0;
		}
	}
	/* 上方空白占位，可根据需要调整高度 */
	.jm-spacer {
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 20px;

		background-color: rgb(246, 246, 246);
	}
	/* 相对定位的容器，固定 1311 x 751 */
	.jm-container {
		position: relative;
		width: 1448px;
		height: 917px;
		overflow: hidden;
		/* 等宽高图片，用作“背景”，不直接写到容器样式上 */
		.jm-bg {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height:817px;
			object-fit: cover;
			pointer-events: none;
			border-radius: 10px;
		}
	}
}

/* 业务内容容器，覆盖在背景图上层 */
.jm-content {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	.shop-name {
		position: absolute;
		top: 10px;
		left: 109px;
		font-size: 14px;
		color: #333;
		background: white;
	}
	.xiaoer-name {
		position: absolute;
		top: 54px;
		left: 132px;
		font-size: 14px;
		color: #333;
		background: white;
	}
    .fast-reply-group {
		position: absolute;
		top: 215px;
		left: 272px;
		width: 1100px;
		height: 45px;
		background: white;
		border-radius: 8px;
		padding: 6px 8px;
		box-sizing: border-box;
		.frg-scroll { display: flex; align-items: center; gap: 16px; height: 100%; overflow-x: auto; overflow-y: hidden;}
		.frg-item { cursor: pointer; flex: none; padding: 6px 14px; background: #f5f7fa; border-radius: 8px; font-size: 14px; color: #606266; white-space: nowrap; }
		.frg-item.active { color: #2d6cf6; }
		.frg-item.frg-add { color: #2d6cf6; }
	}
	.fast-reply-toolbar {
		position: absolute;
		width: 1155px;
		height: 42px;
		left: 271px;
		top: 281px;
		display: flex;
		background-color: white;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
		border-radius: 8px;
		.frt-left { display: flex; align-items: center; gap: 12px; }
		.frt-right { margin-left: auto; display: flex; align-items: center; gap: 12px; }
		.frt-count { color: #333; font-size: 14px; margin-right: 8px; }
		.frt-btn { padding: 6px 14px; border: 1px solid #2d6cf6; color: #2d6cf6; border-radius: 10px; cursor: pointer; background: #fff; }
		.frt-btn-primary { background: #2d6cf6; color: #fff; border-color: #2d6cf6; }
	}
	.fast-reply-list {
		position: absolute;
		width: 1164px;
		height: 478px;
		left: 272px;
		top: 331px;
		padding-right: 30px;
		background-color: white;
		box-sizing: border-box;
		.fr-table { width: 100%; height: 100%; display: flex; flex-direction: column; }
		.fr-tr { display: grid; grid-template-columns: 80px 220px 1fr 180px; align-items: center; }
		.fr-thead { background: #f7f8fa; border-bottom: 1px solid #ebeef5; border-top-left-radius: 8px; border-top-right-radius: 8px; }
		.fr-th { padding: 10px 14px; color: #606266; font-size: 14px; }
		.fr-tbody { overflow: auto; flex: 1; }
		.fr-td { padding: 10px 14px; color: #303133; font-size: 14px; border-bottom: 1px solid #f2f3f5; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.fr-tr:hover .fr-td { background: #f7faff; }
		.col-actions { text-align: center; }
		.fr-op-btn { display: inline-block;  color: #2d6cf6; cursor: pointer; background: #fff; margin-left: 8px; }
		.fr-op-btn.danger { border-color: #f56c6c; color: #f56c6c; }
		.fr-empty { text-align: center; color: #909399; padding: 30px 0; }
	}
	.status-select {
		position: absolute;
        width: 50px;
        left: 86px;
        top: 86px;
        height: 20px;

		/deep/ .el-input__inner {
			height: 20px;
			line-height: 20px;
			padding: 0 0px 0 5px;
			font-size: 13px;
			border: none;
			box-shadow: none;
			border-color: transparent;
			background-color: #f5f5f5;
		}

		/deep/ .el-input.is-focus .el-input__inner,
		/deep/ .el-input__inner:focus,
		/deep/ .el-input__inner:hover {
			border: none !important;
			box-shadow: none !important;
			border-color: transparent !important;
		}

		/deep/ .el-input__icon {
			line-height: 20px;
            width: auto;
		}

		&.status-online {
			/deep/ .el-input__inner {
				background-color: #00b578;
				color: #fff;
			}
			/deep/ .el-select__caret, /deep/ .el-input__icon { color: #fff; }
		}

		&.status-offline {
			/deep/ .el-input__inner {
				background-color: #9e9e9e;
				color: #fff;
			}
			/deep/ .el-select__caret, /deep/ .el-input__icon { color: #fff; }
		}

		&.status-pause {
			/deep/ .el-input__inner {
				background-color: #ff4d4f;
				color: #fff;
			}
			/deep/ .el-select__caret, /deep/ .el-input__icon { color: #fff; }
		}
	}
	.keyword-input {
		position: absolute;
        width: 370px;
        left: 986px;
        top: 60px;
		height: 25px;

		/deep/ .el-input__inner {
			height: 25px;
			line-height: 25px;
			padding: 0 26px 0 8px;
			/* 预留右侧空白给清空按钮 */
			font-size: 13px;
			border: none;
			box-shadow: none;
		}

		/deep/ .el-input__inner:focus,
		/deep/ .el-input__inner:hover {
			border: none !important;
			box-shadow: none !important;
		}

		/deep/ .el-input__suffix {
			right: 8px;
			top: -8px;
			line-height: 25px;
		}
	}
	.chat-msg-input {
		position: absolute;
        width: 621px;
        height: 146px;
        left: 343px;
        top: 622px;
        background: #F7F7F7;
	}
	.reply-textarea {
		position: absolute;
		left: 0px;
		top: 0px;
		width: 621px;
		height: 125px;
		border: none;
		border-radius: 4px 4px 0 0;
		padding: 12px 12px 24px;
		box-sizing: border-box;
		background: transparent;
		font-size: 13px;
		resize: none;
	}
	.chat-msg-toolbar {
		position: absolute;
        left: 804px;
        top: 771px;
		display: flex;
	}
    .add-reply-btn {
        position: absolute;
        width: 356px;
        height: 30px;
        right: 100px;
        bottom: 120px;
        cursor: pointer;
    }
	.orders-list {
		position: absolute;
        width: 409px;
        height: 633px;
        right: 70px;
        top: 40px;
        background: #F5F6FA;
		padding: 10px;
		box-sizing: border-box;
        .order-card { background: #fff; border-radius: 6px; padding: 0; display: flex; flex-direction: column; }
        .oc-head { padding: 10px 12px; border-bottom: 1px solid #f0f0f0; display: flex; flex-direction: column; gap: 4px; }
        .oc-line1 { display: grid; grid-template-columns: auto 1fr auto; align-items: center; gap: 10px; }
        .oc-status { background: #ff7f50; color: #fff; border-radius: 3px; padding: 2px 6px; font-size: 12px; }
        .oc-no { color: #333; font-weight: 600; }
        .oc-icons { display: flex; align-items: center; gap: 6px; }
        .oc-icons i { color: #9aa0a6; }
        .oc-badge { color: #2d6cf6; border: 1px solid #2d6cf6; border-radius: 3px; padding: 0 4px; line-height: 16px; height: 16px; font-size: 12px; }
        .oc-time { color: #999; font-size: 12px; }
        .oc-body { display: flex; gap: 12px; padding: 12px; }
        .oc-img { width: 60px; height: 60; border-radius: 4px; object-fit: cover; background: #f5f5f5; }
        .oc-info { display: flex; flex-direction: column; gap: 6px; width:224px;}
        .oc-title { font-size: 13px; color: #333; line-height: 18px; max-height: 36px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; }
        .oc-tags { display: flex; gap: 8px; }
        .oc-tags span { background: #eef5ff; color: #2d6cf6; border-radius: 3px; padding: 0 6px; height: 20px; line-height: 20px; font-size: 12px; }
        .oc-spec { color: #888; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .oc-code { color: #888; font-size: 12px; }
        .oc-side { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; }
        .oc-price { font-size: 13px; font-weight: 400; }
        .oc-btns { display: flex;gap: 8px;flex-direction: column;width: 65px;}
        .oc-btns .btn { background: #f4f6f8; border-radius: 4px; padding: 6px 8px; font-size: 12px; color: #2d6cf6; text-align: center; cursor: default; }
        .oc-recv { padding: 12px; border-top: 1px solid #f5f5f5; }
        .oc-recv .row { color: #666; font-size: 12px; line-height: 20px; }
        .oc-recv .title { font-weight: 600; margin-bottom: 2px; }
        .oc-ship { padding: 10px 12px; color: #666; font-size: 12px; border-top: 1px dashed #eee; }
        .oc-foot { padding: 10px 12px; border-top: 1px solid #f0f0f0; display: flex; justify-content: space-between; align-items: center; }
        .oc-foot .label { color: #666; }
        .oc-foot .value { color: #e1251b; font-weight: 700; }
        .oc-foot .ship { color: #999; font-style: normal; font-weight: 400; margin-left: 4px; }
	}
	.chat-msg-header {
		position: absolute;
		width: 625px;
		height: 40px;
		left: 342px;
		top: 114px;
		background: white;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 4px 8px;
		box-sizing: border-box;
		border-radius: 4px;
		justify-content: start;
		.cmh-avatar { width: 24px; height: 24px; border-radius: 50%; }
		.cmh-name { font-size: 13px; color: #333; max-width: 520px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.cmh-actions { display: flex; align-items: center; gap: 10px; }
		.cmh-action { color: #9e9e9e; font-size: 18px; cursor: pointer; }
		.cmh-action:hover { color: #666; }
		.cmh-icon-wrap { position: relative; display: inline-flex; align-items: center; justify-content: center; }
		.cmh-icon-wrap .cmh-action { font-size: 18px; }
		.cmh-badge { position: absolute; right: 2px; bottom: -2px; width: 10px; height: 10px; pointer-events: none; background-color: white;}
	}

	

	
	.chat-msg-content {
		position: absolute;
        width: 621px;
        height: 450px;
        left: 342px;
        top: 161px;
        background: #F5F6FA;
        overflow: auto;
        .chat-msg-list { padding: 12px; }
        .msg-item { display: flex; margin-bottom: 14px; justify-content: flex-start; width: 100%;}
        .msg-avatar { width: 32px; height: 32px; margin-right: 8px; border-radius: 50%; }
        .msg-main { width: 100%; }
        .msg-header { color: #999; font-size: 12px; margin-bottom: 6px; }
        .msg-name { margin-right: 8px; color: #666; }
        .msg-text { color: #333; font-size: 14px; line-height: 22px; }
        .msg-image {
            max-width: 300px;
            margin-top: 10px;
            border-radius: 4px;
            object-fit: cover;
        }
        .ref-title { color: red; margin-bottom: 6px; margin-top: 20px; cursor: pointer; }
        .msg-reference { background: #E9F4FF; border-radius: 6px; padding: 10px 12px; }
        .msg-reference .ref-label { color: #F56C6C; margin-bottom: 4px; }
        .msg-reference .ref-body { 
            background: #fff; 
            border-radius: 4px; 
            padding: 10px 12px; 
            color: #E84C3D; 
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }
        .reply-list { margin-top: 10px; display: flex; flex-direction: column; gap: 8px; }
        .reply-item { display: flex; flex-direction: column; justify-content: flex-end; align-items: flex-end;}
        .reply-item .msg-text { color: #333; font-size: 14px; line-height: 22px; text-align: start; margin-right: 42px;max-width: 300px;}
        .msg-header.right { text-align: right; margin-bottom: 4px; }
	}
	.fast-reply-content {
		position: absolute;
        width: 409px;
        height: 600px;
        left: 968px;
        top: 149px;
        background: white;
        overflow: auto;
		/* 快捷短语分组与子项样式 */
		.fr-group { border: 1px solid #e8e8e8; border-radius: 6px; background: #fff; }
		.fr-group-header { padding: 4px 10px; cursor: pointer; user-select: none; display: flex; align-items: center; gap: 6px; background: #f7f8fa; border-bottom: 1px solid #eee; }
		.fr-group-title { font-size: 13px; font-weight: 500; color: #333; }
		.fr-group-body { padding: 6px 8px; }
		.fr-item { display: flex; gap: 6px; font-size: 12px; color: #666; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding: 6px 4px; border-radius: 4px; align-items: center; }
		.fr-item:hover { background: #f5f7fa; }
		.fr-actions { display: none; gap: 10px; flex: none; margin-left: 8px; }
		.fr-actions span { color: #2d6cf6; cursor: pointer; }
		.fr-item:hover .fr-actions { display: inline-flex; }
		.fr-text { flex: 1; overflow: hidden; text-overflow: ellipsis; }
	}
	.train-session-list {
		position: absolute;
		width: 249px;
        height: 600px;
        left: 79px;
        top: 174px;
		overflow: auto;
		background-color: #FDFDFD;
		.ts-item {
			display: flex;
			align-items: center;
			gap: 10px;
			padding: 8px 10px;
			border-radius: 6px;
			transition: background 0.2s ease;
			margin-bottom: 10px;
			background: #fff;
			cursor: pointer;
			&.replied { background: #FFF5CC; }
			&.current { background: #E6F0FF; }
			.ts-avatar {
				width: 28px;
				height: 28px;
				border-radius: 50%;
				background: #e5e6eb;
				flex: none;
			}
			.ts-name { font-size: 13px; color: #333; }
		}
	}
	.action-order-btn {
		position: absolute;
		width: 50px;
		height: 50px;
		right: 10px;
		bottom: 800px;
		cursor: pointer;
	}
	.action-reply-btn {
		position: absolute;
		width: 50px;
		height: 50px;
		right: 10px;
		bottom: 578px;
		cursor: pointer;
	}
	.action-import-btn {
		position: absolute;
		width: 50px;
		height: 50px;
		left: 12px;
		bottom: 510px;
		cursor: pointer;
	}
	.action-chat-btn {
		position: absolute;
		width: 50px;
		height: 50px;
		left: 12px;
		top: 110px;
		cursor: pointer;
	}
}
/* 快捷短语提示框样式 */
.quick-reply-suggestions {
	position: absolute;
	left: 486px;
	top: 585px;
	width: 473px;
	max-height: 210px;
	background: #fff;
	border: 1px solid #e4e7ed;
	border-radius: 4px;
	box-shadow: 0 2px 12px rgba(0,0,0,0.1);
	padding: 4px 0;
	overflow-y: auto;
	z-index: 1000;
	.suggestion-item {
		display: flex;
		align-items: center;
		padding: 8px 12px;
		cursor: pointer;
		border-bottom: 1px solid #f5f7fa;
	}
	.suggestion-item:last-child {
		border-bottom: none;
	}
	.suggestion-item:hover,
	.suggestion-item.active {
		background-color: #f5f7fa;
	}
	.suggestion-text {
		color: #909399;
		font-size: 12px;
		margin-right: 8px;
		min-width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #f5f7fa;
		border: 1px solid #e4e7ed;
		border-radius: 3px;
		font-weight: 500;
	}
	.suggestion-code {
		color: #409eff;
		font-size: 12px;
		margin-right: 8px;
		min-width: 60px;
	}
	.suggestion-content {
		color: #333;
		font-size: 12px;
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
</style>
<style lang='less'>
.transfer-pop { padding: 8px; }
.transfer-pop .tp-tabs { display: flex; gap: 24px; font-size: 14px; color: #666; }
.transfer-pop .tp-tab { cursor: pointer; padding-bottom: 6px; }
.transfer-pop .tp-tab.active { color: #2d6cf6; border-bottom: 3px solid #2d6cf6; }
.transfer-pop .tp-search { margin: 10px 0 8px; }
.transfer-pop .tp-list { max-height: 260px; overflow: auto; background: #fff; border-radius: 4px; }
.transfer-pop .tp-item { display: flex; align-items: center; padding: 10px; border-bottom: 1px solid #f0f0f0; background-color: rgba(232, 229, 229, 0.3);cursor: pointer;}
.transfer-pop .tp-item:last-child { border-bottom: none; }
.transfer-pop .tp-dot { width: 8px; height: 8px; border-radius: 50%; margin-right: 8px; }
.transfer-pop .tp-dot.online { background: #31c24b; }
.transfer-pop .tp-name { flex: 1; color: #333; }
.order-note-pop { padding: 10px 12px; }
.order-note-pop .onp-wrap { display: flex; flex-direction: column; gap: 10px; }
.order-note-pop .onp-head { display: flex; justify-content: space-between; align-items: center; font-size: 14px; color: #333; }
.order-note-pop .onp-history { color: #2d6cf6; font-size: 12px; }
.order-note-pop .onp-flags { display: flex; align-items: center; gap: 10px; }
.order-note-pop .onp-flag { display: flex; align-items: center; gap: 4px; }
.order-note-pop .onp-flag .dot { width: 10px; height: 10px; border-radius: 50%; display: inline-block; }
.order-note-pop .onp-text textarea { resize: vertical; }
.order-note-pop .onp-check { color: #999; font-size: 12px; }
.order-note-pop .onp-foot { display: flex; justify-content: flex-end; gap: 8px; }
</style>



// WEBPACK FOOTER //
// ./src/page/train/FBT/doudianChat.vue